var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"abs r-3 b-0 wh-4 depth-9"},[_c('div',{staticClass:"rel wh-1/1"},[_c('north-icon',{staticClass:"abs-center transition-transform duration-500",style:({ transform: _vm.transform }),attrs:{"width":"48","height":"48","color":"#5A9DF8"}}),_c('p',{staticClass:"abs-center text-white m-0 fs-0.7"},[_vm._v(" N ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }